import script from "./MatchingGame.vue?vue&type=script&setup=true&lang=ts"
export * from "./MatchingGame.vue?vue&type=script&setup=true&lang=ts"

import "./MatchingGame.vue?vue&type=style&index=0&id=1032cfba&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1032cfba"]])

export default __exports__